import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const rootSelector = 'product-price';
    const newRoot = event.detail.data.html.querySelector(rootSelector);
    if (!newRoot) return;

    const newPrice = newRoot.querySelector('[ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (newPrice && currentPrice && currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }

    const newTax = newRoot.querySelector('.price-without-tax-display');
    const currentTax = this.querySelector('.price-without-tax-display');

    if (currentTax && newTax) {
      if (currentTax.innerHTML !== newTax.innerHTML) {
        currentTax.replaceWith(newTax);
      }
    } else if (currentTax && !newTax) {
      currentTax.remove();
    } else if (!currentTax && newTax) {
      const taxNote = this.querySelector('.tax-note');
      if (taxNote && taxNote.parentElement) {
        taxNote.parentElement.insertBefore(newTax, taxNote.nextSibling);
      } else if (currentPrice && currentPrice.parentElement) {
        currentPrice.parentElement.insertBefore(newTax, currentPrice.nextSibling);
      } else {
        this.appendChild(newTax);
      }
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
